// extracted by mini-css-extract-plugin
export var card = "card-module--card--2a143";
export var card_actress = "card-module--card_actress--b29cf";
export var card_capture = "card-module--card_capture--8e2f5";
export var card_date = "card-module--card_date--f9e82";
export var card_lecture = "card-module--card_lecture--ba643";
export var card_title = "card-module--card_title--fe4a7";
export var date_icon = "card-module--date_icon--80306";
export var post_date = "card-module--post_date--7114a";
export var recommend = "card-module--recommend--0b5f1";
export var tags_area = "card-module--tags_area--a2cc1";